// Tracks the difference between this client's system clock and the server's clock,
// derived from the `Date` header every HTTP response already sends. Countdown timers
// (e.g. breakout room expiry) should use `getCorrectedNow()` instead of `Date.now()`
// so they stay accurate even when a client's system clock is wrong, regardless of
// timezone (timezone alone does not affect this — only an inaccurate system clock does).
let clockOffsetMs = 0;

export function updateClockOffsetFromDateHeader(dateHeaderValue?: string): void {
  if (!dateHeaderValue) return;
  const serverTime = new Date(dateHeaderValue).getTime();
  if (Number.isNaN(serverTime)) return;
  clockOffsetMs = serverTime - Date.now();
}

export function getClockOffsetMs(): number {
  return clockOffsetMs;
}

export function getCorrectedNow(): number {
  return Date.now() + clockOffsetMs;
}
